if (!customElements.get('size-guide-media-tabs')) {
  class SizeGuideMediaTabs extends HTMLElement {
    constructor () {
      super();
      this.controls = this.querySelectorAll('.size-guide-media-tab');
      this.contents = this.querySelectorAll('.size-guide-media-tab-content');
    }

    primaryControlHandle (e) {
      const root = e.target.closest('a');
      if (root && !root.hasAttribute('data-active')) {
        const destinationID = root.getAttribute('href');
        if (destinationID) {
          const content = this.querySelector(destinationID);
          if (content) {
            e.preventDefault();
            e.stopPropagation();
            this.controls.forEach((item) => {
              if (item !== root) {
                item.removeAttribute('data-active');
              } else {
                item.setAttribute('data-active', '1');
              }
            });
            this.contents.forEach((item) => {
              if (item !== content) {
                item.removeAttribute('data-active');
              } else {
                item.setAttribute('data-active', '1');
              }
            });
          }
        }
      }
    }

    connectedCallback () {
      this.controls.forEach((item) => {
        item.addEventListener('click', this.primaryControlHandle.bind(this));
      });
    }

    disconnectedCallback () {
      this.controls.forEach((item) => {
        item.removeEventListener('click', this.primaryControlHandle.bind(this));
      });
    }
  }

  customElements.define('size-guide-media-tabs', SizeGuideMediaTabs);
}